import './button.scss';
const Button = (props) => {
    return (
            <div className='adhoc-button text-center' {...props}/>
        );
}
export default Button;